import { useState } from "react";
import { useNavigate } from "react-router";
import { Link } from "react-router-dom";

const SettingSideBox = ({
  activeMenu
}) => {

  const navigate = useNavigate()

  return (
    <div
      className="text-white font-bold"
      style={{
        width: '250px',
        fontSize: '14px'
      }}
    >
      <Link to="/settings/profile">
      <div
        className={
          "py-3 px-5 flex cursor-pointer " +
          (activeMenu === 'profile' ? 'bg-blue-800 border-l-4 border-green-500 rounded-tl-lg rounded-bl-lg' : ' border-l-4 border-transparent ')
        }
      >
        Profil
      </div>
      </Link>
      <Link to="/settings/password">
      <div
        className={
          "py-3 px-5 flex cursor-pointer " +
          (activeMenu === 'password' ? 'bg-blue-800 border-l-4 border-green-500 rounded-tl-lg rounded-bl-lg' : ' border-l-4 border-transparent ')
        }
      >
        Password
      </div>
      </Link>

    </div>
  )

}

export default SettingSideBox;